import React, { useContext } from 'react'
import { Text, View } from 'oio-react'
import PropTypes from 'prop-types'
import NotebookContext from 'src/libraries/contexts/Notebook'
import ProtoThemeContext from 'src/libraries/contexts/ProtoTheme'
import TOCContext from 'src/libraries/contexts/TOC'
import { useOrganization } from 'src/graphql/hooks'

const LayoutContainer = ({ children, noteId }) => {
   const { organization } = useOrganization()
   const { protoTheme: theme } = useContext(ProtoThemeContext)
   const { setTocIsOpen } = useContext(TOCContext)
   const { currentNotebook, useFacingPages, visibleNoteIds } = useContext(NotebookContext)

   return (
      <>
         <View
            position="absolute"
            top="0px"
            bottom="70px"
            left="0px"
            right="0px"
            scroll="on">
            {children}
         </View>
         <View
            display="flex"
            justifyContent="center"
            position="absolute"
            bottom="0px"
            left="0px"
            right="0px"
            height="70px"
            paddingHorizontal={theme.tmpNotePadding}>
            <View
               onClick={() => setTocIsOpen(true)}
               display="flex"
               justifyContent="space-between"
               alignItems="center"
               height="100%"
               width="100%"
               maxWidth={theme.tmpNoteMaxWidth}>
               {(!useFacingPages || visibleNoteIds.length === 1) && (
                  <Text color={theme.tmpNoteMetaTextColor} size="0.8" transform="uppercase">
                     {`${organization.name} — ${currentNotebook?.name}`}
                  </Text>
               )}
               {useFacingPages && visibleNoteIds.length === 2 && (
                  <>
                     {visibleNoteIds.indexOf(noteId) === 0 && (
                        <Text color={theme.tmpNoteMetaTextColor} size="0.8" transform="uppercase">
                           {organization.name}
                        </Text>
                     )}
                     {visibleNoteIds.indexOf(noteId) === 1 && (
                        <Text color={theme.tmpNoteMetaTextColor} size="0.8" transform="uppercase">
                           {`${currentNotebook.name}`}
                        </Text>
                     )}
                  </>
               )}
               <Text color={theme.tmpNoteMetaTextColor} size="0.8" transform="uppercase">
                  1 of 1
               </Text>
            </View>
         </View>
      </>
   )
}

LayoutContainer.propTypes = {
   children: PropTypes.node.isRequired,
   noteId: PropTypes.string.isRequired
}

export default LayoutContainer
